<template>
  <div
    class="d-flex justify-content-between container-content"
    :class="[{ collapse }]"
  >
    <Navbar
      @collapse="toggleNavbar"
      :menuvisibility="menu_visibility"
      @showModalSwitch="showModalSwitch"
    ></Navbar>
    <main>
      <o-switch
        v-if="isModalVisible"
        @closeModalSwitch="closeModalSwitch"
        @showModalSwitch="showModalSwitch"
      ></o-switch>
      <slot></slot>
    </main>
  </div>
  <Footer></Footer>
</template>

<script>
import Navbar from "./navbar.vue";
import Footer from "./footer.vue";
import Switch from "../../views/Switch.vue";
import store from "@/store";
import { useTheme } from "@/composables/useTheme";

export default {
  components: {
    Navbar,
    Footer,
    OSwitch: Switch,
  },
  data: function () {
    return {
      collapse: false,
      menu: {
        root: ["Dashboard", "Corporate", "Feature Flags", "System Log", "API Log", "Switch"],
        corporate: ["Dashboard", "Branch", "User", "Member", "Member Tier", "User Roles", "Benefit", "Tax Service", "Transaction Report", "Themes", "Point Management", "Voucher", "Campaign", "Policies", "Marketing", "Connection Apps", "Promotions", "Newsletter", "Switch"],
        branch: [
          "Dashboard",
          "Merchant",
          "Branch Product",
          "User",
          "Member",
          "Benefit",
          "Marketing",
          "Newsletter",
          "Switch",
          "Tax Service",
          "Transaction Report",
        ],
        merchant: [
          "Dashboard",
          "Member",
          "Product",
          "Transaction",
          "Point Management",
          "Benefit",
          "Voucher",
          "Voucher Redeem",
          "Marketing",
          "Newsletter",
          "Access Token",
          "Authentication URL",
          "Tax Service",
          "Voucher Gift",
          "Voucher Gift History"
        ],

      },
      isModalVisible: false,
    };
  },
  mounted() {
    this.fetchTheme();
    this.fetchFeatureFlag();
    this.$store.dispatch('feature-upsell/fetchContents');
  },
  watch: {
    selectedBusinessProfile: {
      handler(newProfile) {
        if (newProfile && newProfile.corporate_id) {
          this.fetchFeatureFlag();
        }
      },
      deep: true
    }
  },
  methods: {
    sendSignal(reRender) {
      store.commit('ReloadHome/setNeedsReRender', reRender);
    },
    toggleNavbar() {
      this.collapse = !this.collapse;
    },
    menuSelection(user, selectedBusinessProfile) {
      if (["root", "corporate", "branch", "merchant"].includes(user.level)) {
        if (selectedBusinessProfile.merchant_id || user.level === 'merchant') {
          const merchantMenu = this.getMerchantMenu();
          return user.level === 'merchant' ? merchantMenu.filter(item => item !== 'Switch') : merchantMenu;
        }

        if (selectedBusinessProfile.branch_id) {
          return this.menu.branch;
        }

        if (selectedBusinessProfile.corporate_id) {
          return this.getCorporateMenu();
        }

        this.fetchTheme();

        return this.menu[user.level];
      }

      return this.menu[user.level];
    },
    
    getCorporateMenu() {
      return [...this.menu.corporate];
    },
    
    getMerchantMenu() {
      const pointFlag = this.$store.state.FeatureFlag?.pointControl?.flag || 'DECENTRALIZE';
      const baseMenu = [...this.menu.merchant];

      // When NONACTIVE, merchant has no point management access
      if (pointFlag === 'NONACTIVE') {
        const filteredMenu = baseMenu.filter(item => item !== 'Point Management');
        return [...filteredMenu, "Switch"];
      }

      return [...baseMenu, "Switch"];
    },
    showModalSwitch() {
      this.isModalVisible = !this.isModalVisible;
    },
    closeModalSwitch(reRender) {
      this.isModalVisible = false;
      this.sendSignal(reRender);
    },
    fetchTheme() {
        const corporateId = this.selectedBusinessProfile.corporate_id;
        if (corporateId) {
            const { applyTheme } = useTheme();
            applyTheme(corporateId);
        }
    },
    fetchFeatureFlag() {
      const corporateId = this.selectedBusinessProfile.corporate_id;
      if (corporateId) {
        this.$store.dispatch('FeatureFlag/fetchFeatureFlag', corporateId)
          .catch(error => {
            console.error('Error fetching feature flag:', error);
          });
      }
    },
  },
  computed: {
    user: function () {
      return store.state.Auth.currUser;
    },
    selectedBusinessProfile: function () {
      return store.state.Auth.selectedBusinessProfile;
    },
    menu_visibility: function () {
      // filteredMenu will handle permission-based filtering and needs to be reactive to feature flag changes
      if (Object.keys(this.user).length !== 0 && this.user.constructor === Object) {
        return this.menuSelection(this.user, this.selectedBusinessProfile);
      }

      return [];
    },
    pointControlFlag() {
      return this.$store.state.FeatureFlag?.pointControl?.flag || 'DECENTRALIZE'
    }
  },
};
</script>

<style scoped>
.container-content.collapse main {
  padding-left: 60px;
}

main {
  width: 100%;
  padding-left: 240px;
  transition: all 0.3s ease-in-out;
}

@media (max-width: 768px)
{
  main {
    padding-left: 0px;
    margin-bottom: 5rem;
  }
}

.container-content {
  min-height: 100vh;
}

.custom-postion-user-info{
  margin-left: 400px;
}

</style>
